import { StatusCodeError } from './error/StatusCodeError';
import { StatusFalseError } from './error/StatusFalseError';

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const AUTHORIZATION = process.env.REACT_APP_AUTHORIZATION || '';

export function fetchData(route: string, init: RequestInit = {}, baseUrl?: string): Promise<Response> {
    const apiBaseUrl = baseUrl || BASE_URL;
    return fetch(`${apiBaseUrl}/${route}`, {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            Authorization: AUTHORIZATION,
        },
        credentials: 'omit',
    })
        .then(handleStatusCodeError)
        .then(handleStatusFalseError)
        .then((res): Response => {
            const newRes = res.clone();
            newRes.json = () => new Promise((resolve, reject) => {
                res.json()
                    .then((data: { result: string }) => {
                        resolve(JSON.parse(data.result));
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });

            return newRes;
        });
}

function handleStatusCodeError(response: Response): Response {
    if (!response.ok) {
        throw new StatusCodeError(response);
    }

    return response;
}

function handleStatusFalseError(response: Response): Promise<Response> {
    return new Promise((resolve, reject) => {
        response.clone().json().then((resData) => {
            const data = JSON.parse(resData.result);
            if (data.status && data.status === 'FALSE') {
                const newRes = response.clone();
                newRes.json = () => new Promise((resolve, reject) => {
                    response.json()
                        .then((data: { result: string }) => {
                            resolve(JSON.parse(data.result));
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
                reject(new StatusFalseError(newRes));
            } else {
                resolve(response);
            }
        }).catch((e) => {
            reject(e);
        });
    });
}
